import axios from 'axios';

/**
 * Client for the coupon API endpoints
 */
class CouponClient {
  constructor(backendUrl) {
    this.backendUrl = backendUrl;
  }

  /**
   * Get all coupons for a company
   */
  async getCoupons(companyId) {
    return axios.get(`${this.backendUrl}/coupons`, {
      params: { companyId },
      headers: {
        'X-User-Id': localStorage.getItem('userId'),
        'X-Company-Id': companyId
      }
    });
  }

  /**
   * Create a new coupon
   */
  async createCoupon(couponData) {
    return axios.post(`${this.backendUrl}/coupons`, couponData, {
      headers: {
        'X-User-Id': localStorage.getItem('userId'),
        'X-Company-Id': couponData.companyId
      }
    });
  }

  /**
   * Update a coupon
   */
  async updateCoupon(couponId, couponData) {
    return axios.put(`${this.backendUrl}/coupons/${couponId}`, couponData, {
      headers: {
        'X-User-Id': localStorage.getItem('userId'),
        'X-Company-Id': couponData.companyId
      }
    });
  }

  /**
   * Delete a coupon
   */
  async deleteCoupon(couponId) {
    return axios.delete(`${this.backendUrl}/coupons/${couponId}`, {
      headers: {
        'X-User-Id': localStorage.getItem('userId')
      }
    });
  }
}

export default CouponClient;
